import React from 'react';

import { reorderableList } from 'helpers/react_dnd/reorderable_list';
import SelectedColumnRow, { type Column } from './row';

type Props = {
  selectedColumns: Column[];
  onDeselectColumn: (column: Column) => void;
  onReorderColumns: () => void;
}

function SelectedColumnList({ selectedColumns, onDeselectColumn, onReorderColumns }: Props) {
  return (
    <div className=" d-flex flex-column gap-2">
      {selectedColumns.map((column: Column, index: number) => (
        <SelectedColumnRow
          column={column}
          index={index}
          key={column.value}
          onDeselectColumn={() => onDeselectColumn(column)}
          onReorder={onReorderColumns}
        />
      ))}
    </div>
  );
}

export default reorderableList(SelectedColumnList);
